import { trackEvent } from '@farmnet/tag-manager';

angular.module('cfn').controller('cattleController', cattleController);

cattleController.$inject = [
  '$scope',
  '$location'
];
function cattleController(
  $scope,
  $location
) {
  $scope.hasRight = app.hasRight;
  $scope.hasFunctionalAnalysisRight = app.hasRight('Company:FUNCTIONAL_ANALYSIS');
  $scope.hasCompanyPlanningRight = app.hasRight('Company:PLANNING');
  $scope.hasPreliminaryBookingRight = app.hasRight(
      'Company:PRELIMINARY_BOOKING'
  );

  $scope.state = {};

  $scope.trackCattleNavigation = (title) => {
    const navigationLabel = `Cattle::${title}`;

    trackEvent('Navigation', 'Body', navigationLabel);
  };

  $scope.switchView = 'management';

  $scope.switchSegments = [
    {
      label: 'fe.menu.cattle.switchView.dashboard',
      onSelect() {
        $scope.switchView = 'management';
        $location.path('/dairynet.presentation/dashboard');
      },
      selected: $scope.switchView === 'dashboard'
    },
    {
      label: 'fe.menu.cattle.switchView.management',
      onSelect() {
        $scope.switchView = 'dashboard';
      },
      selected: $scope.switchView === 'management'
    }
];

  return ($scope.cattleController = this);
}
